module.exports = __webpack_public_path__ + "img/pic_news_bottom@2x.e59d1dc0.png";